import { motion } from "framer-motion";
import { Tv, Smartphone, Apple, Cast } from "lucide-react";

const devices = [
  { icon: Tv, name: "Smart TV", note: "Samsung, LG y más" },
  { icon: Cast, name: "Firestick", note: "Amazon Fire TV" },
  { icon: Smartphone, name: "Android", note: "Móvil, Tablet y TV Box" },
  { icon: Apple, name: "Apple", note: "iPhone, iPad y Apple TV" },
];

export const Devices = () => {
  return (
    <section
      id="dispositivos"
      data-testid="devices-section"
      className="relative py-24 lg:py-32 border-y border-bp-border overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/9807277/pexels-photo-9807277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Noche de películas en casa"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-bp-bg/85" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Compatibilidad total</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            Míralo donde quieras, como quieras
          </h2>
          <p className="mt-4 text-[#A3A3A3]">
            BrothersPlus TV funciona en todos tus dispositivos favoritos. Configúralo en minutos y empieza a disfrutar.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {devices.map((d, i) => (
            <motion.div
              key={d.name}
              data-testid="device-card"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="group glass rounded-2xl p-8 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1 hover:border-bp-primary/40"
            >
              <d.icon className="w-12 h-12 text-[#A3A3A3] transition-colors group-hover:text-white" strokeWidth={1.4} />
              <h3 className="font-heading text-lg font-medium text-white mt-5">{d.name}</h3>
              <p className="text-xs text-[#737373] mt-1">{d.note}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
